import React from "react";
import "./RiskMatrixCoverage.scss";

// Barras de cobertura del paso "Resumen" del workspace — espejo de covRow()
// del prototipo. `rows` ya viene calculado por metodología (ver
// riskMatrixCoverage.js), cada fila es {label, pct, note}.
export function RiskMatrixCoverage({ rows }) {
  if (!rows || rows.length === 0) return null;

  return (
    <div className="risk-matrix-coverage">
      {rows.map((row) => (
        <div key={row.label} className="risk-matrix-coverage__row">
          <span className="risk-matrix-coverage__label">{row.label}</span>
          <div className="risk-matrix-coverage__bar">
            <div
              className="risk-matrix-coverage__bar-fill"
              style={{ width: `${Math.max(0, Math.min(100, row.pct))}%` }}
            />
          </div>
          <span className="risk-matrix-coverage__note">{row.note}</span>
        </div>
      ))}
    </div>
  );
}
